import { logDebugging } from '../../log/logger';

export default class PlayerEvent {
  constructor(evtName) {
    this.STATE_EVENT = 'STATE_EVENT';
    this.VOLUME_EVENT = 'VOLUME_EVENT';
    this.CHANGE_VOLUME_EVENT = 'CHANGE_VOLUME_EVENT';
    this.QUARTILES_EVENT = 'CHANGE_VOLUME_EVENT';
    this.THROW_MIDROLL = 'THROW_MIDROLL';
    this.THROW_POSROLL = 'THROW_POSROLL'; // EVENTO QUE SE UTILIZAR PARA CARGAR LA PUBLICIDAD DE POSROLL Y TENERLA PREPARADA PARA EL STOP DEL VIDEO
    this.THROW_OVERLAY = 'THROW_OVERLAY';
    this.THROW_PREROLL = 'THROW_PREROLL';
    this.INIT_PREROLL = 'INIT_PREROLL';
    // name of the event
    this.eventName = evtName;

    // function to call on event fire
    this.eventAction = null;
  }

  // subscribe a function to the event
  subscribe(fn) {
    this.eventAction = fn;
  }

  unsubscribe() {
    this.eventAction = null;
  }

  // fire the event
  fire(sender, eventArgs) {
    if (this.eventAction != null) {
      this.eventAction(sender, eventArgs);
    } else {
      logDebugging(`Nothing subscribed to the ${this.eventName} event!`);
    }
  }
}
